import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import Flickity from 'flickity';
import 'jquery-parallax.js';
import 'isotope-layout/dist/isotope.pkgd.js';
import 'lightgallery/dist/js/lightgallery-all';
import 'imagesloaded/imagesloaded.pkgd.js';

import 'select2/dist/js/select2.js';

import 'jquery-match-height/dist/jquery.matchHeight.js';

fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	function preventDefault(e) {
	  e = e || window.event;
	  if (e.preventDefault)
		  e.preventDefault();
	  e.returnValue = false;  
	}

	function keydown(e) {
		for (var i = keys.length; i--;) {
			if (e.keyCode === keys[i]) {
				preventDefault(e);
				return;
			}
		}
	}

	function wheel(e) {
	  preventDefault(e);
	}

	function disable_scroll() {
	  if (window.addEventListener) {
		  window.addEventListener('DOMMouseScroll', wheel, false);
	  }
	  window.onmousewheel = document.onmousewheel = wheel;
	  document.onkeydown = keydown;
	}

	function enable_scroll() {
		if (window.removeEventListener) {
			window.removeEventListener('DOMMouseScroll', wheel, false);
		}
		window.onmousewheel = document.onmousewheel = document.onkeydown = null;  
	}	

	function myAddParameterAndReturn(url, paramName, paramValue)
	{
	    if (url.indexOf(paramName + "=") >= 0)
	    {
	        var prefix = url.substring(0, url.indexOf(paramName));
	        var suffix = url.substring(url.indexOf(paramName));
	        suffix = suffix.substring(suffix.indexOf("=") + 1);
	        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
	        url = prefix + paramName + "=" + paramValue + suffix;
	    }
	    else
	    {
	    if (url.indexOf("?") < 0)
	        url += "?" + paramName + "=" + paramValue;
	    else
	        url += "&" + paramName + "=" + paramValue;
	    }
	    return url;
	}

	function requestMarkers(map, url, oms){
	    deleteMarkers();
	    $.ajax({
	      dataType: "json",
	      url: url,
	    }).done(function(json) {
	      $.each(json, function(index, elem){
	        console.log(elem);
	        geoMarkers.push({
	             "type": "Feature",
	             "geometry": {
	                 "type": "Point",
	                 "coordinates": [
	                     elem.address.lng,
	                     elem.address.lat
	                 ]
	             },
	             "properties": {
	                 "postid" : elem.post.ID,
	                 "link": elem.permalink,
	                 "marker": elem.markerIcon,
					 "disable_link": elem.disable_ref_single ? "true" : "false"
	             }
	         });
	      });
	      oms.removeAllMarkers();
	      setMarkers(map, geoMarkers, oms);
	    })
	}
	
	function setMarkers(map, geoMarkers, oms){
	    var geojson =
	    {
	        "type": "FeatureCollection",
	        "features": geoMarkers
	        
	    };
	    
	    //console.log(geojson);
	    if (geojson.features.length >= 1) {
	        var bounds = new google.maps.LatLngBounds();	        
	        geojson.features.forEach(function(feature) {
	          if (feature.geometry.coordinates[1] && feature.geometry.coordinates[0]) {
	            var icon = new google.maps.MarkerImage(
	                        feature.properties.marker,
	                        new google.maps.Size(28,39),
	                        null,
	                        null,
	                        new google.maps.Size(28,39)
	                    );
	            
	            var markerpos = new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
	            var marker = new google.maps.Marker({
	              position: markerpos,
	              map: map,
	              title: '',
	              animation: google.maps.Animation.DROP,
	              url: feature.properties.link,
	              icon: icon,
				  disable_link: feature.properties.disable_link
	            });

	            oms.addMarker(marker);
	            //googleMapMarkers.push(marker);
	          //  console.log(feature)
	            google.maps.event.addListener(marker, 'spider_click', function() {
					if (this.disable_link !== "true") { // Check if disable_link is not "true"
						window.open(this.url); // Only open the link if disable_link is not "true"
					}
	            });
	            bounds.extend(markerpos);
	            }
	        });
	        google.maps.event.trigger(map, "resize");
	        $('.loadingOverlay').hide();
	        if (geoMarkers.length > 1) {
	          map.fitBounds(bounds);
	          setTimeout(function(){
	          	map.setZoom(map.getZoom() - 1);
	          }, 100)
	          
	        } else {
	          map.fitBounds(bounds);
	          map.setZoom(12);
	        }
	    };
	}

	function deleteMarkers() {
	    for (var i = 0; i < googleMapMarkers.length; i++) {
	        googleMapMarkers[i].setMap(null);
	    }
	    googleMapMarkers = [];
	    geoMarkers  = [];
	}

	var geoMarkers = [];
	var googleMapMarkers = [];

	function is_touch_device() {
	  return 'ontouchstart' in window        // works on most browsers 
	      || navigator.maxTouchPoints;       // works on IE10/11 and Surface
	};


	$('.galleryInner').lightGallery({
			selector: '.galItem'
		});

		$('.toBottom').on('click', function(){
			$('html, body').animate({
				scrollTop: $('#content').offset().top -125
			}, 1000);
		})

		$('.gallery').lightGallery({
			selector: '.gallery-item a'
		});

		$('.casawp-main-flickity').lightGallery({
			selector: '.property-image-gallery',
			download: false,
			thumbnail: false
		});


		$('.navbar-toggler').on('click', function(){
			if ($(this).hasClass('active-nav')) {
				$(this).removeClass('active-nav');
				$('.navbarOuter').removeClass('nav-bg');
			} else {
				$(this).addClass('active-nav');
				setTimeout(function(){
					$('.navbarOuter').addClass('nav-bg');
				}, 200);
			}
		});


		$('.casadistance__menu__button').on('click', function(){
			$('html, body').animate({
				scrollTop: $('.casadistance__menu').offset().top - 125
			}, 500);
		});
		

		$('.navbar-collapse').on('shown.bs.collapse', function(){
			setTimeout(function(){
				$('.topOuter').css('height', 'auto');
				$('.topOuter').css('min-height', 'unset');
				if ($('#header').hasClass('fixedHeader')) {
					$('#header').removeClass('fixedHeader');
				}
				$('#footer').hide();
				$('#content').hide();
				$('.sliderOuter').hide();

				$('html, body').animate({
					scrollTop: $('.navbar-collapse').offset().top - 125
				}, 0);
			}, 500)
			
			
		});

		if ($('.wpforms-field-radio').length) {
			$('.wpforms-field-radio li label').append('<span class="checkmark"></span>');
		}

		$('.navbar-collapse').on('show.bs.collapse', function(){
			$('html, body').animate({
				scrollTop: $('#content').offset().top - 125
			}, 500);
		});

		$('.navbar-collapse').on('hidden.bs.collapse', function(){
		});

		$('.navbar-collapse').on('hide.bs.collapse', function(){
			setTimeout(function(){
				$('#header').removeAttr( 'style' );
			}, 500);
			$('.topOuter').removeAttr( 'style' );
			$('#footer').fadeIn();
			$('#content').fadeIn();
			$('.sliderOuter').fadeIn();
			$('html, body').animate({
				scrollTop: $('#content').offset().top - 125
			}, 0);
		});

		$('#navigation .menu-item-has-children > a, #navigation .wpml-ls-item > .wpml-ls-item-toggle').on('click', function(e){
			e.preventDefault();
			if ($(this).parent().find('ul').hasClass('sub-menu-active')) {
				$(this).parent().find('ul').removeClass('sub-menu-active');
			} else {
				$('.sub-menu, .wpml-ls-sub-menu').removeClass('sub-menu-active');
				$(this).parent().find('ul').addClass('sub-menu-active');
			}
			$('html, body').animate({
				scrollTop: $('#header').offset().top
			}, 500);
			return false;
		});

		$('p:empty').remove();


		$('.navbar-collapse .navbar-nav > li > a').prepend('<svg width="17px" height="7px" viewBox="0 0 17 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <g id="Navigation-open" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-360.000000, -259.000000)" stroke-linecap="round">        <g id="Group-2" transform="translate(361.000000, 260.000000)" stroke="#1985A1" stroke-width="1.5"><path d="M0.5,2.5 L13.5,2.5" id="Line"></path><polyline id="Path-2" points="11 0 13.9166667 2.5 11 5"></polyline></g></g></svg>');

		$('.navOuter .menu-item-has-children > a, .wpml-ls-item a:first').append('<i class="fal fa-angle-down"></i>');

		$('<i class="fal fa-angle-down"></i>').insertAfter('.form-control-singleselect').hide();

		if (!is_touch_device()) {
			$('.form-control-singleselect').nextAll().show();
		}

		$('.form-group select').parent().append('<i class="fal fa-angle-down"></i>');

		if ($('.wpforms-field-select').length) {
			$('.wpforms-field-select').append('<i class="fal fa-angle-down"></i>');
		}

		if ($('.wpforms-submit-container').length) {
			$('.wpforms-submit-container .btn-primary').append('<svg width="32px" height="7px" viewBox="0 0 32 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Startseite-Copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-235.000000, -2056.000000)" stroke-linecap="round"><g id="Group-2" transform="translate(236.000000, 2057.000000)" stroke="#ffffff" stroke-width="1.5"><path d="M0.5,2.5 L28.5,2.5" id="Line"></path><polyline id="Path-2" points="26 0 28.9166667 2.5 26 5"></polyline></g></g></svg>');
		}

		var textTop = $('.casawp-shortcode-properties-shortcode-list .casawp-property').outerHeight() - $('.casawp-shortcode-properties-shortcode-list .casawp-property .casawp-text h3').outerHeight();

		$('.casawp-shortcode-properties-shortcode-list .casawp-property .casawp-text').css('top', textTop);

		$('.casawp-shortcode-properties-shortcode-list .casawp-property').on('click', function(){
			if ($(this).hasClass('activeProperty')) {
				$(this).removeClass('activeProperty');
			} else {
				$('.casawp-shortcode-properties-shortcode-list .casawp-property').removeClass('activeProperty');
				$(this).addClass('activeProperty');
			}
		});

		$(window).on('scroll', function(){
			if ($(window).scrollTop() > $('.topOuter').outerHeight() - $('.blocker').outerHeight()) {
				$('.home #header').addClass('fixedHeader');
			} else {
				$('.home #header').removeClass('fixedHeader');
			}
		});

		if ($(window).scrollTop() > $('.topOuter').outerHeight() - $('.blocker').outerHeight()) {
			$('.home #header').addClass('fixedHeader');
		} else {
			$('.home #header').removeClass('fixedHeader');
		}



		if ($('.casawp-shortcode-properties').length) {
			var shortFlickity = new Flickity('.casawp-shortcode-properties', {
				cellAlign: 'left',
				contain: true,
				imagesLoaded: true,
				pageDots: true,
				prevNextButtons: false,
				draggable: true,
				autoPlay: 7000
			});
			window.addEventListener( 'load', function() {
			  shortFlickity.resize();
			});
		}

		if ($('.testiSlider').length) {
			var testiSlider = new Flickity('.testiSlider', {
				cellAlign: 'left',
				wrapAround: true,
				imagesLoaded: true,
				pageDots: true,
				prevNextButtons: false,
				draggable: true,
				autoPlay: 7000,
				adaptiveHeight: true
			});
		}

		if ($('.slider').length) {
			var slider = new Flickity('.slider', {
				cellAlign: 'left',
				wrapAround: true,
				imagesLoaded: true,
				pageDots: false,
				prevNextButtons: false,
				draggable: false,
				autoPlay: 7000
			});
		}

		if ($('.casawp-main-flickity').length) {
			var immoSlider = new Flickity('.casawp-main-flickity', {
				cellAlign: 'center',
				autoPlay: 7000,
				draggable: false,
				wrapAround: true,
				pageDots: true,
				imagesLoaded: true,
				prevNextButtons: true
			});
			window.addEventListener( 'load', function() {
			  immoSlider.resize();
			});
		}

		if ($('.matchHeight').length) {
			$('.matchHeight').matchHeight();
		}
		
		
		//$('.teamGrid .grid-item').height($('.member').outerHeight());
		
		$('.flickity-prev-next-button.previous svg').replaceWith('<svg width="25px" height="7px" viewBox="0 0 25 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Objektdetails-Copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-53.000000, -346.000000)" stroke-linecap="round"><g id="Group" transform="translate(66.000000, 349.500000) scale(-1, 1) translate(-66.000000, -349.500000) translate(55.000000, 347.000000)" stroke="#FFFFFF" stroke-width="1.5"><path d="M0.5,2.5 L21.5,2.5" id="Line"></path><polyline id="Path-2" points="19 0 21.9166667 2.5 19 5"></polyline></g></g></svg>');
		$('.flickity-prev-next-button.next svg').replaceWith('<svg width="25px" height="7px" viewBox="0 0 25 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Objektdetails-Copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1365.000000, -346.000000)" stroke-linecap="round"><g id="Group" transform="translate(1366.000000, 347.000000)" stroke="#FFFFFF" stroke-width="1.5"><path d="M0.5,2.5 L21.5,2.5" id="Line"></path><polyline id="Path-2" points="19 0 21.9166667 2.5 19 5"></polyline></g></g></svg>');

		if ($('.grid').length) {
			var $grid = $('.grid').isotope({
				itemSelector: '.grid-item'
			});

			$grid.imagesLoaded().progress( function() {
				$grid.isotope({
					itemSelector: '.grid-item'
				});
			});
		}

		if ($('.filters-select').length) {
			$('.filters-select').select2();

			$('.filters-select').on( 'change', function() {
			  // get filter value from option value
			  
			  var maxHeight = 0;

			  $('.grid-item').each(function(){
				 var thisH = $(this).height();
				 if (thisH > maxHeight) { maxHeight = thisH; }
			  });

			  $('.grid-item').height(maxHeight);
			  var filterValue = this.value;
			 // console.log(filterValue);
			  // use filterFn if matches value
			  $grid.isotope({ filter: filterValue });
			  
			});
		}

		$('.toggle-map').on('click', function(e){
			e.preventDefault();
			if ($('.map-wrap').hasClass('map-wrap--hidden')) {
				$('.map-wrap').removeClass('map-wrap--hidden');
				$(this).find('.show-map').addClass('d-none');
				$(this).find('.hide-map').removeClass('d-none');
				if ($('#casawp-map').length) {
					initializeMapBoxCasaWP();
					disable_scroll();
					$('html, body').stop().animate({
						scrollTop: $('#casawp-map').offset().top - $('#header').outerHeight()
					}, 700, function () {
						enable_scroll();
					});
				};
			} else {
				$('.map-wrap').addClass('map-wrap--hidden');
				$(this).find('.show-map').removeClass('d-none');
				$(this).find('.hide-map').addClass('d-none');
				disable_scroll();
				$('html, body').stop().animate({
					scrollTop: $('.map-wrap').offset().top - $('#header').outerHeight()
				}, 700, function () {
					enable_scroll();
				});
			}
			return false;
		});

		if ($('.map-wrap--always').length) {
			initializeMapBoxCasaWP();
		}
		

		function initializeMapBoxCasaWP() {

			var style = [
				{
				"elementType": "geometry",
				"stylers": [
				  {
					"color": "#f5f5f5"
				  }
				]
				},
				{
				"elementType": "labels.icon",
				"stylers": [
				  {
					"visibility": "off"
				  }
				]
				},
				{
				"elementType": "labels.text.fill",
				"stylers": [
				  {
					"color": "#616161"
				  }
				]
				},
				{
				"elementType": "labels.text.stroke",
				"stylers": [
				  {
					"color": "#f5f5f5"
				  }
				]
				},
				{
				"featureType": "administrative.land_parcel",
				"elementType": "labels.text.fill",
				"stylers": [
				  {
					"color": "#bdbdbd"
				  }
				]
				},
				{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [
				  {
					"color": "#eeeeee"
				  }
				]
				},
				{
				"featureType": "poi",
				"elementType": "labels.text.fill",
				"stylers": [
				  {
					"color": "#757575"
				  }
				]
				},
				{
				"featureType": "poi.park",
				"elementType": "geometry",
				"stylers": [
				  {
					"color": "#e5e5e5"
				  }
				]
				},
				{
				"featureType": "poi.park",
				"elementType": "labels.text.fill",
				"stylers": [
				  {
					"color": "#9e9e9e"
				  }
				]
				},
				{
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [
				  {
					"color": "#ffffff"
				  }
				]
				},
				{
				"featureType": "road.arterial",
				"elementType": "labels.text.fill",
				"stylers": [
				  {
					"color": "#757575"
				  }
				]
				},
				{
				"featureType": "road.highway",
				"elementType": "geometry",
				"stylers": [
				  {
					"color": "#dadada"
				  }
				]
				},
				{
				"featureType": "road.highway",
				"elementType": "labels.text.fill",
				"stylers": [
				  {
					"color": "#616161"
				  }
				]
				},
				{
				"featureType": "road.local",
				"elementType": "labels.text.fill",
				"stylers": [
				  {
					"color": "#9e9e9e"
				  }
				]
				},
				{
				"featureType": "transit.line",
				"elementType": "geometry",
				"stylers": [
				  {
					"color": "#e5e5e5"
				  }
				]
				},
				{
				"featureType": "transit.station",
				"elementType": "geometry",
				"stylers": [
				  {
					"color": "#eeeeee"
				  }
				]
				},
				{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
				  {
					"color": "#c9c9c9"
				  }
				]
				},
				{
				"featureType": "water",
				"elementType": "labels.text.fill",
				"stylers": [
				  {
					"color": "#9e9e9e"
				  }
				]
				}
			]

			var mapOptions = {
				center: {lat: 47.247913, lng: 8.674145},
				zoom: 14,
				disableDefaultUI: false,
				zoomControl: true,
				mapTypeControlOptions: {
					 mapTypeIds: ['roadmap', 'hybrid']
				  },
				styles: style
			};
			var map = new google.maps.Map(document.getElementById('casawp-map'), mapOptions);

			var oms = new OverlappingMarkerSpiderfier(map, {
			  markersWontMove: false,
			  markersWontHide: false,
			  basicFormatEvents: false
			});


			
			if ($('.casawp-property').length > 0) {
				$('.loadingOverlay').removeAttr('style');
			}
			
			if (!$('.casawp-archive').hasClass('refArchive')) {
				var $form = $('.casawp-filterform');
				var filteredParams = $form.serialize();
				var url = $form.prop('action');
				url = url.replace(window.location.protocol + "//" + window.location.host, '');
				var url_last = window.location.href.split("?");

				var filteredUrl = myAddParameterAndReturn(url + '?' + url_last[1], 'ajax', '1');
				filteredUrl = myAddParameterAndReturn(filteredUrl, 'posts_per_page', '999');
				filteredUrl = myAddParameterAndReturn(filteredUrl, 'json', '1');
				//console.log(filteredUrl);
				requestMarkers(map, filteredUrl, oms);

				$('.casawp-filterform').on( "casawp-ajaxfilter:filter-submit", function(event, url, filteredUrl){
					requestMarkers(map, filteredUrl+"&ajax=1&posts_per_page=999&json=1", oms);
				});
			} else {
				requestMarkers(map, '/immobilien/?availabilities%5B%5D=reference&salestypes=&utilities=&categories=&locations=&rooms_from=&rooms_to=&features=&ajax=1&posts_per_page=100&json=1', oms);
			}
		}


		$('.casawp-ajax-archive-list').on( "casawp-ajaxfilter:after-list-reload", function(event, url, filteredUrl){
		  var width = $(window).width(); 
		  if (width <= 768) {
		   $('html, body').animate({
			scrollTop: $('.contentWrap').offset().top
		   }, 1000);
		  }
		});
		

		function initializeMap($mapwraper) {
			if ($('.marker').length) {
				var markerIcon = $('.marker').data('marker');
			}
			var location = new google.maps.LatLng($mapwraper.data('lat'),$mapwraper.data('lng'));
			var mapOptions = {
			  zoom: parseInt(window.casawpOptionParams.google_maps_zoomlevel),
			  mapTypeId: google.maps.MapTypeId.ROADMAP,
			  center: location,
			  mapTypeControlOptions: {
				mapTypeIds: ['gray_map', google.maps.MapTypeId.SATELLITE]
			  }
			};
			$mapwraper.show();
			map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

			var marker = new google.maps.Marker({
				map: map,
				position: location,
				icon: new google.maps.MarkerImage(
						markerIcon,
						new google.maps.Size(28,39),
						null,
						null,
						new google.maps.Size(28,39)
					)
			});
			map.mapTypes.set('gray_map',
				new google.maps.StyledMapType([{stylers: [{saturation: -90}]}],
					{name: "Gray Map"}));
			map.setMapTypeId('gray_map');
		}
	    
	   if ($('.casawp-map').length && google) {
		   $('.casawp-map').each(function(){
			   var $mapwraper = $(this);
			   if ($mapwraper.data('lat') && $mapwraper.data('lng')) {
				   //var map;
				   if ($('#casawp-mapShowBtn').length) {
					   $('#casawp-mapShowBtn').on('click', function() {
						   console.log("click");
						   if ($('#casawp-mapShowBtn').length) {
							   $('#casawp-mapShowBtn').css('display', 'none');
						   }
						   if ($('.casawp-map__placeholder').length) {
							   $('.casawp-map__placeholder').css('display', 'none');
						   }
						   $('.casawp-map').css('display', 'block');
						   initializeMap($mapwraper);
					   });
				   } else {
					   initializeMap($mapwraper);
				   }
			   }
		   });
	   }

	// Akkordeon
	if ($('.panel__content.show').length) {
		var contentHeight = $(this).find('.panel__content__inner').outerHeight() + 20;
		$('.panel__content.show').css({'height': contentHeight, 'padding-top': '20px'});
	}

	$(window).on('resize', function(){
		var contentHeight = $(this).find('.panel__content__inner').outerHeight() + 20;
		$('.panel__content.show').css({'height': contentHeight, 'padding-top': '20px'});
	});

	$('.panel a').on('click', function(e){
		e.preventDefault();
		if ($(this).hasClass('collapsed')) {
			$('.panel__header a').addClass('collapsed');
			$(this).removeClass('collapsed');
			$(".panel__content").not($(this).parent().next()).removeClass('show');
			$(this).parent().next().addClass('show');
			$('.panel__content').css({'height': '0', 'padding-top': '0'});
			contentHeight = $(this).parent().next().find('.panel__content__inner').outerHeight() + 20;
			$('.panel__content.show').css({'height': contentHeight, 'padding-top': '20px'});
		} else {
			$(this).addClass('collapsed');
			$(this).parent().next().removeClass('show');
			$(this).parent().next().css({'height': '0', 'padding-top': '0'});
		}
		return false;
	});

});



// WEBPACK FOOTER //
// ./src/js/main.js